<template>
  <div class="TableBase">
    <v-card-text v-if="searchActive && dataVals !== null">
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Buscar"
        single-line
        hide-details
      ></v-text-field>
    </v-card-text>

    <v-data-table
      dense
      :headers="headers"
      :items="dataVals"
      :search="search"
      :custom-filter="customFilter"
      no-results-text="No se encontro el término buscado"
      no-data-text="No hay datos disponibles"
      multi-sort
      disable-initial-sort
      class="elevation-1"
      loading="Cargando... Por favor espere."
      rows-per-page-text="Filas por página:"
    >
      <template slot="items" slot-scope="props">
        <td
          v-for="col in columns"
          :key="col.id"
          :align="align(props.item[col])"
        >
        <template v-if="props.item[col] != null">
            <template v-if="props.item[col].url">
              <v-icon
                large
                @click="openLink(props.item[col].url)"
                color="green darken-2"
              >
              cloud_download
              </v-icon>
            </template>
            <template v-else-if="col==='sede'">

              {{ props.item[col] }}
            </template>
            <template v-else-if="col==='proceso'">

              {{ props.item[col] }}
            </template>
            <template v-else-if="col==='gerencia'">

              {{ props.item[col] }}
            </template>

            <template v-else-if="(props.item[col])==='1'">
                <v-icon
                  x-large

                  color="green darken-2"
                >
                done
                </v-icon>

            </template>
            <template v-else-if="(props.item[col])==='2'">
                <v-icon
                  x-large

                  color="red darken-2"
                >
                close
                </v-icon>

            </template>

            <template v-else>
              <template v-if="col==='s3'">
                <template v-if=" parseFloat(props.item[col])>37.4"><h2 class="red--text text--darken-2"> {{ props.item[col] }}</h2></template>
                <template v-else><h3 > {{ props.item[col] }}</h3></template>

              </template>
              <template v-else>
                {{ props.item[col] }}
              </template>

            </template>
          </template>
          <template v-else>
            No disponible
          </template>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: 'TableBaseWithIcons',

  /**
   * Elementos que recibe el componente para renderizar
   */
  props: {
    /** Cabecera de la tabla */
    headers: {
      type: Array,
      required: true
    },
    /** Contenido de la tabla */
    dataVals: {
      type: Array,
      required: true
    },
    /** Habilita o desahbilita la busqueda */
    searchActive: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data: function () {
    return {
      search: '',
      rowsPerPageItems: [5, 10, 20, 50, { 'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1 }]
    }
  },

  computed: {
    /**
     * Devuelve los valores de los identificadores de las columnas de la tabla
     * @return {[Array]} valores de los id de columnas
     */
    'columns': function columns () {
      if (this.headers.length === 0) {
        return []
      }

      var colVals = []
      this.headers.forEach(function (element) {
        colVals.push(element.value)
      })
      return colVals
    }
  },

  methods: {
    /**
     * Determina la alineación de la celda, si es string se alinea a la izquierda
     * para los demas casos se alinea a la derecha
     * @param  {string} val El valor a evaluar
     * @return {string}      La alineación a usar
     */
    align (val) {
      let algn = 'right'
      let type = typeof val

      switch (type) {
        case 'string':
          if (val[val.length - 1] === '%' || val[val.length - 2] === '.') {
            algn = 'left'
          } else {
            algn = 'left'
          }
          break
        case 'number':
          algn = 'left'
          break
        default:
          algn = 'left'
      }

      return algn
    },
    /**
     * funcion para Abrir en una pestaña nueva el
     * url que se le da como parametro
     * @param  {string} url  Url a abrir
     */
    openLink (url) {
      window.open(url)
    }
  }
}
</script>
